import React from 'react'
import { Grid, Box, Badge } from '@mui/material'
import { Link } from 'react-router-dom'
import { MessageBadgesProps } from './types'

const MessageBadges: React.FC<MessageBadgesProps> = ({
    item,
    kedo,
    showAdditionalContent,
}) => {
    const userId = kedo.user().getUserId()
    const findMyRecipient = item.recipients.find(
        (reciep) => reciep.recipient_id === userId
    )

    if (findMyRecipient) {
        return (
            <Grid container>
                <Grid
                    size={12}
                    className={`${showAdditionalContent ? 'messageSD' : ''}`}
                    sx={{ mb: '7px' }}
                >
                    <Box display="flex" alignItems="center">
                        <Link to={`/user/${item.sender_id}`}>
                            <Badge
                                color="primary"
                                className="badge badge-primary"
                                badgeContent={item.sender_name}
                                sx={{
                                    '& .MuiBadge-badge': {
                                        position: 'static',
                                        transform: 'none',
                                        px: 1.5,
                                    },
                                }}
                            />
                        </Link>

                        <Box sx={{ ml: 'auto' }}>
                            <Badge
                                color="secondary"
                                className="badge badge-secondary"
                                badgeContent={kedo
                                    .utils()
                                    .dateFormat(item.created_at)}
                                sx={{
                                    '& .MuiBadge-badge': {
                                        position: 'static',
                                        transform: 'none',
                                        mt: showAdditionalContent ? '7px' : 0,
                                    },
                                }}
                            />
                        </Box>
                    </Box>
                </Grid>
            </Grid>
        )
    } else if (item.sender_id === userId) {
        const receiverIds = item.recipients.map(
            (receiver) => receiver.recipient_id
        )
        const receiverNames = item.recipients.map(
            (receiver) => receiver.recipient_name
        )

        return (
            <Grid container>
                <Grid
                    size={12}
                    className={`${showAdditionalContent ? 'messageSD' : ''}`}
                    sx={{ mb: '7px' }}
                >
                    <Box display="flex" alignItems="center">
                        <Link to={`/user/${receiverIds}`}>
                            <Badge
                                color="primary"
                                className="badge badge-primary"
                                badgeContent={`${kedo.t(
                                    'Receiver'
                                )}: ${receiverNames}`}
                                sx={{
                                    '& .MuiBadge-badge': {
                                        position: 'static',
                                        transform: 'none',
                                        px: 1.5,
                                    },
                                }}
                            />
                        </Link>

                        <Box sx={{ ml: 'auto' }}>
                            <Badge
                                color="secondary"
                                className="badge badge-secondary"
                                badgeContent={kedo
                                    .utils()
                                    .dateFormat(item.created_at)}
                                sx={{
                                    '& .MuiBadge-badge': {
                                        position: 'static',
                                        transform: 'none',
                                        mt: showAdditionalContent ? '7px' : 0,
                                    },
                                }}
                            />
                        </Box>
                    </Box>
                </Grid>
            </Grid>
        )
    }

    return null
}

export default MessageBadges
